import React from "react";
import { Popover, PopoverHeader, PopoverBody } from 'reactstrap';

import './Popover.scss'

const popover = ({ popoverOpen,target, handleToggle,title,pbody,classname,placement}) => {
    return (
        <Popover className={classname} placement={placement} isOpen={popoverOpen} target={target} toggle={handleToggle}>
        <PopoverHeader>{title}</PopoverHeader>
            <PopoverBody>{pbody}</PopoverBody>
        </Popover>
    );
  };
  
  export default popover;